// modais
import ConexaBotStoreModal from "../../components/ConexaBot/storeModal";

// icones
import SearchIcon from "@material-ui/icons/Search";
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import AccountTreeIcon from '@material-ui/icons/AccountTree';

// utilitarios
import { Box, Button, Grid, InputAdornment, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Typography, Switch } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { useContext, useEffect, useReducer, useState } from "react";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import socket from "../../hooks/useSocket";
import SingleSelect from "../../components/InputStyled/singleSelect";
import ConfirmationModal from "../../components/ConfirmationModal";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const initialState = [];

const reducer = (state = initialState, action) => {
  if (action.type === "LOAD_CONEXABOTS") {
    const conexaBots = action.payload;
    return !conexaBots ? [] : conexaBots;
  }

  if (action.type === "UPDATE_CONEXABOTS") {
    let { conexaBot } = action.payload;
    if (!conexaBot) conexaBot = action.payload;
    if (!conexaBot) return;

    const cbIndex = state.findIndex((c) => c.id == conexaBot.id);

    if (cbIndex !== -1) {
      state[cbIndex] = conexaBot;
      return [...state];
    } else {
      return [conexaBot, ...state];
    }
  }

  if (action.type === "DELETE_CONEXABOT") {
    const conexaBotId = action.payload;

    const cbIndex = state.findIndex((u) => u.id === conexaBotId);
    if (cbIndex !== -1) {
      state.splice(cbIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(String(a).toLowerCase(), String(b).toLowerCase(), orderBy)
    : (a, b) => -descendingComparator(String(a).toLowerCase(), String(b).toLowerCase(), orderBy);
}

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "name",
    disablePadding: true,
    label: i18n.t("conexaBots.table.name"),
    sortable: true,
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: i18n.t("conexaBots.table.createdAt"),
    sortable: true,
  },
  {
    id: "connectionName",
    disablePadding: false,
    label: i18n.t("conexaBots.table.connectionName"),
    sortable: true,
  },
  {
    id: "startWithContactMessage",
    disablePadding: false,
    label: i18n.t("conexaBots.table.startWithContactMessage"),
    sortable: true,
  },
  {
    id: "status",
    disablePadding: false,
    label: i18n.t("conexaBots.table.status"),
    sortable: true,
  },
  {
    id: "actions",
    numeric: true,
    disablePadding: false,
    label: i18n.t("conexaBots.table.actions"),
    sortable: false,
    align: "center"
  },
];

const EnhancedTableHead = (props) => {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <>
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => {
            const isSortable = headCell.sortable !== false; // Verifica se a coluna é ordenável
            return (
              <TableCell
                key={headCell.id}
                align={headCell.align || "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={
                  isSortable && orderBy === headCell.id ? order : false
                }
              >
                {isSortable ? (
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : "asc"}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <span className={classes.visuallyHidden}>
                        {order === "desc"
                          ? "sorted descending"
                          : "sorted ascending"}
                      </span>
                    ) : null}
                  </TableSortLabel>
                ) : (
                  headCell.label // Sem TableSortLabel para colunas não ordenáveis
                )}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    </>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  modalStyle: {
    padding: "20px",
    maxheight: "95vh!important",
    minWidth: "670px",
    background: "#ffffff",
    marginTop: "10px",
    marginLeft: "10px",
    marginRight: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
    "@media (max-width: 740px)": {
      padding: "0px !important",
      marginTop: "65px",
    }
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  searchInput: {
    float: "right",
    marginRight: "10px",
    "&>div": {
      backgroundColor: "rgba(0,0,0,0)",
      height: "38px",
      lineHeight: "38px",
      "&>div": {
        marginTop: "0!important"
      }
    },
    "& input": {
      height: "38px",
      lineHeight: "38px",
      padding: "0"
    }
  },
  addButton: {
    float: "right",
    height: "38px"
  }
}));

export default function EnhancedTable() {
  const { user } = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchParam, setSearchParam] = useState("");
  const [enterSearchParam, setEnterSearchParam] = useState(null);
  const [loading, setLoading] = useState(false);
  const [conexaBots, dispatch] = useReducer(reducer, []);
  const [total, setTotal] = useState(0);
  const [selectedConexaBot, setSelectedConexaBot] = useState(null);
  const [deletingConexaBot, setDeletingConexaBot] = useState(null);
  const [conexaBotModalOpen, setConexaBotModalOpen] = useState(false);

  const [conexaBotStatus, setConexaBotStatus] = useState("true");
  const totalPages = Math.ceil(total / rowsPerPage);

  const history = useHistory();

  const FilteredConexaBot = (cBot) => {

    if (!cBot) return false;

    // se estiver pesquisando não atualizar
    if (enterSearchParam && enterSearchParam != "" && enterSearchParam != "undefined") return false;

    // verificar status
    if (((conexaBotStatus == "1" || conexaBotStatus == true || conexaBotStatus == "true") && cBot?.status != true) || ((conexaBotStatus == "0" || conexaBotStatus == false || conexaBotStatus == "false") && cBot?.status != false)) return false;

    return true;
  }

  useEffect(() => {
    const userEventName = `conexaBot-${user.adminId}`;
    const userEventFunction = async (data) => {
      if (data.action === "update" || data.action === "create") {
        if (FilteredConexaBot(data.conexaBot) == true) {
          dispatch({ type: "UPDATE_CONEXABOTS", payload: data.conexaBot });
        } else {
          // se não passou no filtro e existe na lista atual, remover
          const uIdx = conexaBots.findIndex(u => u.id == data?.conexaBot?.id);
          if (uIdx != -1) {
            dispatch({ type: "DELETE_CONEXABOT", payload: +data.conexaBot.id });
          }
        }
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONEXABOT", payload: +data.conexaBotId });
      }
    };
    socket.on(userEventName, userEventFunction);

    return () => {
      socket.off(userEventName, userEventFunction);
    };
  }, [, conexaBots]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {

    let isMounted = true;
    const abortController = new AbortController();

    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get("/conexaBot/", {
          params: {
            page,
            rowsPerPage,
            order,
            orderBy,
            searchParam,
            status: conexaBotStatus
          },
          signal: abortController.signal,
        });
        if (!isMounted) {
          setLoading(false);
          return;
        }
        dispatch({ type: "LOAD_CONEXABOTS", payload: data.conexaBots }); // Verifique se o payload é o esperado
        setTotal(data.total);
      } catch (err) {
        if (!isMounted || err.name == 'AbortError') {
          setLoading(false);
          return;
        }
        console.error(err);
        toastError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [, page, rowsPerPage, order, orderBy, enterSearchParam, conexaBotStatus]);

  const handleChangePage = (event, newPage) => {
    // Verifica se a nova página está dentro dos limites
    if (newPage < 0) {
      setPage(1);
    } else if (newPage >= totalPages) {
      setPage(totalPages - 1);
    } else {
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const searchByText = () => {
    if (!searchParam || searchParam == "undefined") return;
    setEnterSearchParam(!enterSearchParam);
  }

  const handleSearch = (event) => {
    if (event.key == "Enter") {
      searchByText();
      return;
    }

    let str = String(event.target.value).trim().toLowerCase();
    if (str == "undefined") str = "";

    setSearchParam(str);
    if (str == "" || str == null) searchByText();

  };

  const handleOpenConexaBotModal = () => {
    setSelectedConexaBot(null);
    setConexaBotModalOpen(true);
  };

  const handleCloseConexaBotModal = () => {
    setSelectedConexaBot(null);
    setConexaBotModalOpen(false);
  };

  const handleEditConexaBot = (conexaBot) => {
    setSelectedConexaBot(conexaBot);
    setConexaBotModalOpen(true);
  };

  const handleConexaBotStatus = async (conexaBot) => {
    try {
      // resgatar filas da conexão e usuário
      setLoading(true);
      const { data } = await api.put(`/conexaBot/${conexaBot.id}`, {
        ...conexaBot,
        status: conexaBot.status == true ? false : true
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error({ err });
      toastError(err);
    }
  }

  const handleConexaBotStartWithContactMessage = async (conexaBot) => {
    try {
      // resgatar filas da conexão e usuário
      setLoading(true);
      const { data } = await api.put(`/conexaBot/${conexaBot.id}`, {
        ...conexaBot,
        startWithContactMessage: conexaBot.startWithContactMessage == true ? false : true
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error({ err });
      toastError(err);
    }
  }

  const handleDeleteConexaBot = async (conexaBotId) => {
    try {
      await api.delete(`/conexaBot/${conexaBotId}`);
      toast.success(i18n.t("conexaBots.toasts.deleted"));
    } catch (err) {
      console.error({ err });
      toastError(err);
    }
  };

  return (
    <>
      <Box component="div" className={classes.modalStyle} id="box">
        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <Typography variant="h5" style={{ fontWeight: "600" }}>{i18n.t("conexaBots.title")}</Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenConexaBotModal}
              className={classes.addButton}
            >
              <AddOutlinedIcon />
              {i18n.t("conexaBots.buttons.add")}
            </Button>
            <TextField
              placeholder={i18n.t("conexaBots.search")}
              variant="filled"
              type="search"
              value={searchParam}
              background="transparent"
              className={classes.searchInput}
              onKeyDown={handleSearch}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "gray" }} onClick={searchByText} />
                  </InputAdornment>
                ),
              }}
            />
            <SingleSelect
              closeOnSelect={true}
              disabled={false}
              displayText={i18n.t("conexaBots.table.selectStatus")}
              title={undefined}
              options={[{ key: 'false', value: i18n.t("conexaBots.table.disabled"), disabled: false }, { key: 'true', value: i18n.t("conexaBots.table.enabled"), disabled: false }]}
              key={`selectStatusUserFilter`}
              onSelected={(status) => {
                setConexaBotStatus(status);
              }}
              selected={conexaBotStatus}
              style={{
                width: "200px",
                float: "right",
                marginRight: "10px",
                height: "38px",
                lineHeight: "38px",
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} mb={2}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={conexaBots?.length || 0}
                />
                {loading ? (
                  <TableBody>
                    <TableRowSkeleton avatar columns={5} />
                  </TableBody>
                ) : (
                  <TableBody>
                    {!conexaBots || conexaBots?.length == 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={headCells.length}
                          align="center"
                        >
                          {i18n.t('conexaBots.table.notFound')}
                        </TableCell>
                      </TableRow>
                    ) : (
                      stableSort(
                        conexaBots,
                        getComparator(order, orderBy)
                      ).map((row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                            style={{
                              position: "relative",
                              height: "70px",
                            }}
                          >
                            <TableCell align="left">{row.name}</TableCell>
                            <TableCell align="left">{row.createdAt}</TableCell>
                            <TableCell align="left">{row?.Connection?.name || ''}</TableCell>
                            <TableCell align="left">
                              <Switch
                                checked={row?.startWithContactMessage == true ? true : false}
                                onChange={() => handleConexaBotStartWithContactMessage(row)}
                                color="primary"
                                name={`changeStartWithContactMessage-${row.id}`}
                              />
                            </TableCell>
                            <TableCell align="left">
                              <Switch
                                checked={row?.status == true ? true : false}
                                onChange={() => handleConexaBotStatus(row)}
                                color="primary"
                                name={`changeStatus-${row.id}`}
                              />
                            </TableCell>
                            <TableCell style={{ width: 195 }}>
                              {
                                conexaBotStatus == "true" &&
                                <>
                                  <Button
                                    title={i18n.t('buttons.manager')}
                                    onClick={() => {
                                      if (row.status == false) return;
                                      // history.push(`/ConexaBot/manager/${row.id}`);
                                      window.open(`/ConexaBot/manager/${row.id}`, "_blank", "noopener,noreferrer");
                                    }}
                                  >
                                    <AccountTreeIcon />
                                  </Button>
                                  <Button
                                    title={i18n.t('buttons.edit')}
                                    onClick={() => {
                                      if (row.status == false) return;
                                      handleEditConexaBot(row);
                                    }}
                                  >
                                    <EditOutlinedIcon />
                                  </Button>
                                </>
                              }
                              {
                                conexaBotStatus == "false" &&
                                <Button
                                  title={i18n.t('buttons.delete')}
                                  onClick={() => {
                                    setDeletingConexaBot(row);
                                  }}
                                >
                                  <DeleteOutlinedIcon />
                                </Button>
                              }
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page - 1}
              labelRowsPerPage={i18n.t("conexaBots.table.resultPerPage")}
              labelDisplayedRows={({ from, to, count }) =>
                `${i18n.t("conexaBots.table.total")} ${count} / ${i18n.t("conexaBots.table.of")} ${from} ${i18n.t("conexaBots.table.to")} ${to}`
              }
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </Grid>
      </Box>
      <ConexaBotStoreModal
        open={conexaBotModalOpen}
        onClose={handleCloseConexaBotModal}
        aria-labelledby="form-dialog-title"
        conexaBotId={selectedConexaBot && selectedConexaBot.id}
        userEditing={user.id}
      />
      <ConfirmationModal
        title={deletingConexaBot && i18n.t("conexaBots.deleteModal.title")}
        open={deletingConexaBot != null}
        onClose={() => setDeletingConexaBot(null)}
        onConfirm={() => handleDeleteConexaBot(deletingConexaBot?.id)}
      >
        {`${i18n.t("conexaBots.deleteModal.message")} ${deletingConexaBot?.name}?`}
      </ConfirmationModal>
    </>
  );
};